import React from "react";
import styles from "./styles.module.scss";

export const NumberInput = ({
  id,
  name,
  label,
  value,
  min = 0,
  max,
  suffix,
  touched = false,
  errored = false,
  error = "",
  onChange,
  ...props
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    
    // Allow empty value
    if (inputValue === "") {
      onChange("");
      return;
    }
    
    const newValue = parseInt(inputValue);
    
    // Handle invalid number
    if (isNaN(newValue)) {
      onChange("");
      return;
    }
    
    // Handle max/min constraints
    if (max !== undefined && newValue > max) {
      onChange(max);
      return;
    }
    
    if (min !== undefined && newValue < min) {
      onChange(min);
      return;
    }
    
    onChange(newValue);
  };

  return (
    <div className={styles.formGroup}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={styles.inputWrapper}>
        <input
          className={`${styles.input} ${suffix ? styles.suffixInput : ""}`}
          type="number"
          id={id}
          name={name}
          value={value}
          min={min}
          max={max}
          onChange={handleChange}
          {...props}
        />
        {suffix && <span className={styles.suffix}>{suffix}</span>}
      </div>
      {touched && errored && error && (
        <span className={styles.error}>{error}</span>
      )}
    </div>
  );
};

export default NumberInput; 